// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-help .ui-list-row {
  margin-top: calc(-1 * var(--space-2));
}

/* What's in the kit: feature tile left, two tiles stacked right. */
.shop-kit {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: var(--space-8) 0 var(--space-4);
}

.shop-kit-header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.shop-kit-header h2 {
  margin: 0;
}

.shop-kit-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  grid-template-rows: auto auto;
  gap: var(--space-5);
}

.shop-kit-item:first-child {
  grid-row: 1 / span 2;
}

.shop-kit-figure {
  margin: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.shop-kit-media {
  border-radius: var(--radius-lg);
  background: var(--bg-secondary, #f2f2f2);
}

.shop-kit-media > img {
  object-fit: cover;
}

/* The feature tile grows to match the height of the stacked pair. */
.shop-kit-item:first-child .shop-kit-media {
  flex: 1 1;
  min-height: 0;
}

.shop-kit-caption {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.shop-kit-caption-title {
  font-weight: 700;
  color: var(--text-primary);
}

.shop-kit-caption-text {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

/* Phones: feature tile full width, mug and bowl side by side below. */
@media (max-width: 700px) {
  .shop-kit {
    margin-top: var(--space-6);
  }

  .shop-kit-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-4) var(--space-3);
  }

  .shop-kit-item:first-child {
    grid-row: auto;
    grid-column: 1 / -1;
  }

  .shop-kit-item:first-child .shop-kit-media {
    flex: none;
  }

  .shop-kit-caption-text {
    font-size: 0.8125rem;
  }
}

/* Show the whole kit photo on phones instead of a tight 16:9 crop. */
@media (max-width: 820px) {
  .starter-kit.ui-hero-panel--split > .ui-hero-media {
    aspect-ratio: 4 / 3;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Shopping/shopping.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,oDAAoD;EACpD,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".shop-help .ui-list-row {\n  margin-top: calc(-1 * var(--space-2));\n}\n\n/* What's in the kit: feature tile left, two tiles stacked right. */\n.shop-kit {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  margin: var(--space-8) 0 var(--space-4);\n}\n\n.shop-kit-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.shop-kit-header h2 {\n  margin: 0;\n}\n\n.shop-kit-grid {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  grid-template-rows: auto auto;\n  gap: var(--space-5);\n}\n\n.shop-kit-item:first-child {\n  grid-row: 1 / span 2;\n}\n\n.shop-kit-figure {\n  margin: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.shop-kit-media {\n  border-radius: var(--radius-lg);\n  background: var(--bg-secondary, #f2f2f2);\n}\n\n.shop-kit-media > img {\n  object-fit: cover;\n}\n\n/* The feature tile grows to match the height of the stacked pair. */\n.shop-kit-item:first-child .shop-kit-media {\n  flex: 1;\n  min-height: 0;\n}\n\n.shop-kit-caption {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.shop-kit-caption-title {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.shop-kit-caption-text {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n/* Phones: feature tile full width, mug and bowl side by side below. */\n@media (max-width: 700px) {\n  .shop-kit {\n    margin-top: var(--space-6);\n  }\n\n  .shop-kit-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-4) var(--space-3);\n  }\n\n  .shop-kit-item:first-child {\n    grid-row: auto;\n    grid-column: 1 / -1;\n  }\n\n  .shop-kit-item:first-child .shop-kit-media {\n    flex: none;\n  }\n\n  .shop-kit-caption-text {\n    font-size: 0.8125rem;\n  }\n}\n\n/* Show the whole kit photo on phones instead of a tight 16:9 crop. */\n@media (max-width: 820px) {\n  .starter-kit.ui-hero-panel--split > .ui-hero-media {\n    aspect-ratio: 4 / 3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
